import React from "react";

const ExerciseSetModal = ({
  selectedExercise,
  selectedExerciseEmom,
  emomIterations,
  handleModalClose,
  handleModalCloseEmom,
  handleAddSetClick,
  handleSaveSet,
  handleSaveSetEmom,
  handleSetChange,
  handleSetChangeEmom,
  deleteSets,
  wid,
  widd,
}) => {
  if (selectedExerciseEmom) {
    return (
      <div className="excercise-modal">
        <div className="child-modal">
          <div className="add-excersie">
            <button className="button" onClick={() => handleSaveSetEmom()}>
              Save sets
            </button>
            <i className="fa fa-times" onClick={handleModalCloseEmom}></i>
          </div>
          <h3 style={{ fontSize: "15px", fontWeight: "bold" }}>
            {selectedExerciseEmom?.name}
          </h3>

          {selectedExerciseEmom?.sets?.length > 0 && (
            <div>
              {Array.from({ length: emomIterations }).map((_, index) => (
                <div key={index}>
                  <h4 className="titlesmall">Set {index + 1}</h4>
                  <ul className="sets-ul">
                    {selectedExerciseEmom?.sets[0]?.inputs?.map(
                      (input, inputIndex) => (
                        <li key={input?.id}>
                          <div className="left">
                            <span className="name">{input.field_name}</span>
                            <span className="value">{input.unit}</span>
                          </div>
                          <div className="rightt">
                            <input
                              type="number"
                              min={0}
                              value={input?.value}
                              onChange={(e) =>
                                handleSetChangeEmom(
                                  index,
                                  inputIndex,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  if (selectedExercise) {
    return (
      <div className="excercise-modal">
        <div className="child-modal">
          <div className="add-excersie">
            <button className="button" onClick={handleAddSetClick}>
              Add new set
            </button>
            <button className="button" onClick={() => handleSaveSet()}>
              Save sets
            </button>
            <i className="fa fa-times" onClick={handleModalClose}></i>
          </div>
          <h3 style={{ fontSize: "15px", fontWeight: "bold" }}>
            {selectedExercise?.name}
          </h3>
          {selectedExercise.sets.map((set, setIndex) => (
            <div key={set.id}>
              <h4 className="titlesmall">
                Set {setIndex + 1}
                {setIndex > 0 && (
                  <i
                    className="fa fa-trash"
                    onClick={() => deleteSets(set.id, wid || widd)}
                  ></i>
                )}
              </h4>
              <ul className="sets-ul">
                {set?.inputs?.map((input, inputIndex) => (
                  <li key={input?.id}>
                    <div className="left">
                      <span className="name">{input.field_name}</span>
                      <span className="value">{input.unit}</span>
                    </div>
                    <div className="rightt">
                      <input
                        type="number"
                        min={0}
                        value={input?.value !== null ? input?.value : 0}
                        onChange={(e) =>
                          handleSetChange(
                            setIndex,
                            inputIndex,
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return null;
};

export default ExerciseSetModal;
